export default "__VITE_ASSET__5babdf2a__"